import * as React from 'react';

const alertMessage = (props) => {
  // type: primary, secondary, success, danger, warning, info, light, dark
  return (
    <div className={`alert alert-${props.type ? props.type : 'primary'}`} role="alert">
      <div dangerouslySetInnerHTML={{ __html: props.children }} />
    </div>
  )
}

export default alertMessage;